<template>

    <Base>
    <template v-slot:basecontent>
      <div class="rounded-xl pt-[16px] pb-[32px] px-[24px] w-[391px] bg-theme-grey">
        <div class="hello mt-5 mb-3 text-center">Password Setup</div>
          <p class="text-[16px] text-center text-white">
            Looks like it’s your first time here, let’s begin by setting up your new
            password!
          </p>
          <form @submit.prevent="onSubmit()" ref="forgotPassForm_">
          
          <div :class="'input-wrapper relative ' + (form.password.error_type)">
            <label class="mt-3 block label-text">New Password </label>
            <div class="relative">
              <input
                class="shadow text-field appearance-none border rounded w-full text-white focus:outline-none focus:shadow-outline"
                v-model="form.password.value"
                :type="showpassword ? 'text' : 'password'"
                
                @keyup="validateBothField()"
              />
              <div class="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 z-30">
                <EyeIcon :class="{'hidden': !showpassword, 'block':showpassword }" @click="showpassword = !showpassword" class="text-white w-5"/>
                <EyeOffIcon :class="{'block': !showpassword, 'hidden':showpassword }" @click="showpassword = !showpassword" class="text-white w-5"/>
              </div>
            </div>
            <p class="field-error label-text mt-1" v-if="form.password.error_message" v-text="form.password.error_message"></p>
          </div>

          <div :class="'input-wrapper ' + (form.confirm_password.error_type)">
            <label class="mt-3 block label-text">Confirm Password </label>
            <div class="relative">
              <input
                class="shadow text-field appearance-none border rounded w-full text-white focus:outline-none focus:shadow-outline"
                v-model="form.confirm_password.value"
                :type="shownewpassword ? 'text' : 'password'"
                @keyup="validateFields(['confirm_password'])"
              />
              <div class="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5 z-30">
                <EyeIcon :class="{'hidden': !shownewpassword, 'block':shownewpassword }" @click="shownewpassword = !shownewpassword" class="text-white w-5"/>
                <EyeOffIcon :class="{'block': !shownewpassword, 'hidden':shownewpassword }" @click="shownewpassword = !shownewpassword" class="text-white w-5"/>
              </div>
            </div>
            <p class="field-error label-text mt-1" v-if="form.confirm_password.error_message" v-text="form.confirm_password.error_message"></p>
          </div>

          <button
            class="mt-8 bg-theme-green hover:bg-theme-darkgreen rounded w-[100%] text-[14px] text-bold text-white p-[8px]"
          >
            SET PASSWORD
          </button>
          </form>
        </div>
      
    </template>
  </Base>
</template>

<script lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { defineComponent, ref } from "vue";
import Base from "./Base.vue";
import { useSnackbar } from "vue3-snackbar";
import { EyeIcon, EyeOffIcon } from '@heroicons/vue/outline'
import LoginApis from "@/controllers/LoginApis";
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/helpers';

export default defineComponent({
  name: "SetPassword",
  components: {
    Base,
    EyeIcon,
    EyeOffIcon
  },
  
  setup() {
    const router = useRouter()
    const route = useRoute()
    const snackbar = useSnackbar();
    const showpassword = ref(false);
    const shownewpassword = ref(false);
    const form = ref({
        password: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'password'],
        },
        confirm_password: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required', 'confirm_password'],
        },
      });
    return {
      form,
      router,
      route,
      showpassword,
      shownewpassword,
      snackbar
    };
  },
  mounted() {
    if(!this.route.query.token || this.route.query.token == '') {
      this.router.push({
        name: 'Login'
      })
    }
  },

  methods: {
    /**
     * Validate both field
     */
    validateBothField() {
       // console.log('validatie')
      if(this.form.confirm_password.value) {
        this.validateFields(['password','confirm_password']);
      } else {      
        this.validateFields(['password']) 
      }
      
    },
    /**
     * Validation captures
     */
    async validateFields(fields) {
      
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },

    /**
     * Submit reset form
     */
    async onSubmit() {

      let validate = await this.validateFields(['password', 'confirm_password']);
      if(!validate) {
        return ;
      }

        this.va_spinner(true);
        let res = await LoginApis.resetPassword({
          token: this.route.query.token,
          password:  this.form.password.value
        })
        this.va_spinner(false);
        this.snackbar.add({
          type: 'info',
          text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
        if(res.status == 201) {
          this.router.push({
            name: 'Login'
          })
        }
    },

    /**
     * Sometimes user add confirm password then password , at that time
     */
    validateConfirmField() {
      // console.log('validatie')
      // if(this.form.confirm_password.value) {
      //   this.validateFields(['confirm_password']);
      // }
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
    })

  },
  
});
</script>
